import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from '../sidebar/sidebar.component';

@Component({
  selector: 'app-layout',
  template: `
    <app-sidebar></app-sidebar>
    <router-outlet class="hidden"></router-outlet>
  `,
  styles: `
  `,
  standalone: true,
  imports: [CommonModule, SidebarComponent, RouterModule],
})
export class LayoutComponent {
  // Workaround needed when using msal service, otherwise when logging out it starts a loop
}
